module.exports = __webpack_public_path__ + "img/bcr.3cd5fe58.png";